const removeItem = key => localStorage.removeItem(key);

const getItem = (key, defaultValue = null) => {
  const item = localStorage.getItem(key);
  const nowDate = new Date();

  if (item) {
    const { expiry } = item;

    if (expiry && nowDate.getTime() > item.expiry) {
      removeItem(key);

      return null;
    }

    return JSON.parse(item);
  }

  return defaultValue;
};

const setItem = (key, value, expiryTime = null) => {
  const item = { ...value };

  if (expiryTime) {
    const nowDate = new Date();

    item.expiry = nowDate.getTime() + expiryTime;
  }

  localStorage.setItem(key, JSON.stringify(item));
};

export { removeItem, getItem, setItem };
